export default __webpack_public_path__ + "images/b067f6fc4e8cad45116c9d7dc51d323f.png";